<template>
    <div>
        <h3 class="title_header">角色管理</h3>
        <div class="from_header">
            <el-button
                    type="primary"
                    @click="getAddRole"
            >新增
            </el-button>
        </div>


        <el-table
                :data="tableData"
                style="width: 100%"
                :row-class-name="tableRowClassName">
            <el-table-column type="index" width="200" label="序号" align="center">
            </el-table-column>
            <el-table-column
                    prop="roleName"
                    label="角色名"
                    align="center"
            >
            </el-table-column>
            <el-table-column
                    prop="roleDescription"
                    label="角色描述"
                    align="center"
            >
            </el-table-column>


            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button
                            size="mini"
                            @click="goUpdate(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button
                            size="mini"
                            type="danger"
                            @click="deleteEmployee(scope.$index, scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination class="pagination_bottom"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="parseInt(query.pageNum)"
                       :total="query.total"
                       :page-size="query.pageSize"
                       :page-sizes="[1,10, 20, 50,100, 200]"
                       layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>

    </div>


</template>

<script>

    export default {
        data() {
            return {

                teamList: {},

                query: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0,
                },
                tableData: [],


            }
        },
        methods: {

            handleSizeChange(val) {
                this.query.pageSize = val;
                this.list();
            },
            handleCurrentChange(val) {
                this.query.pageNum = val;
                this.list();
            },
            //设置表格颜色
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 1) {
                    return 'warning-row';
                } else if (rowIndex === 3) {
                    return 'success-row';
                }
                return '';
            },

            /**
             * 跳转添加页面
             * */
            getAddRole() {
                this.$router.push({name: "PlatformuserRoleAdd"});
            },
            /**
             * 舔砖编辑页面
             * */
            goUpdate(index, row) {
                this.$router.push({name: "PlatformuserRoleAdd", query: {pid: row.pid}});
            },

            deleteEmployee(index, row) {
                this.$confirm('此操作将永久删除: 【' + row.roleName + '】 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$post(this.$url.角色删除, {pid: row.pid}).then((res) => {
                        //如果当前页码 - 1  * 页大小  刚好 = 总数 -1 ，则需要让页码 -1 为了解决一页最后一个被删除后，无法获取到上一页的数据
                        if (this.query.pageNum > 1) {
                            if ((this.query.pageNum - 1) * this.query.pageSize === this.query.total - 1) {
                                this.query.pageNum--;
                            }
                        }
                        this.list();
                    }).catch((err) => {
                        //this.$message.error(err.info);
                    });
                }).catch(() => {
                });
            },

            /**
             * 数据列表
             */
            list() {
                this.$post(this.$url.角色列表, this.query).then((res) => {
                    this.tableData = res.list;
                    this.query.total = parseInt(res.total);
                }).catch((err) => {
                    this.tableData = [];
                });
            },
            init() {
                this.list();
            }
        },
        mounted() {
            this.init();
        }
    }
</script>

<style scoped>
    .title_header {
        text-align: left;
        padding: 20px 20px 10px 20px;
        background-color: #FFFFFF;
        margin-bottom: 3px;
    }

    .pagination_bottom {
        text-align: right;
        background-color: #FFFFFF;
        padding: 22px 20px;

    }

    .from_header {
        background-color: #FFFFFF;
        padding: 15px 0 0 10px;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .inner-container {
        height: 450px;
        width: 300px;
        overflow-y: auto;
    }

    /* for Chrome */
    .inner-container::-webkit-scrollbar {
        display: none;
    }

</style>
